import { render, staticRenderFns } from "./WorkLocation.vue?vue&type=template&id=dfb88168&"
import script from "./WorkLocation.vue?vue&type=script&lang=js&"
export * from "./WorkLocation.vue?vue&type=script&lang=js&"
import style0 from "./WorkLocation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports